let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => {
        try {
          return Promise.resolve(callback(data));
        } catch (error) {
          console.error(`Error in ${eventName} subscriber:`, error);
          return Promise.resolve();
        }
      });
    return Promise.allSettled(promises).then((results) => {
      const errors = results.filter(r => r.status === 'rejected');
      if (errors.length > 0) {
        console.warn(`${errors.length} subscriber(s) failed for event: ${eventName}`);
      }
      return results;
    });
  } else {
    return Promise.resolve();
  }
}
